import createIcon from '../../createIcon';

/**
 * @component @name TableView
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgN0g5QzcuOSA3IDcgNy45IDcgOVYxOUM3IDIwLjEgNy45IDIxIDkgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjlDMjEgNy45IDIwLjEgNyAxOSA3Wk0xOSA5VjExSDlWOUgxOVpNMTMgMTVWMTNIMTVWMTVIMTNaTTE1IDE3VjE5SDEzVjE3SDE1Wk0xMSAxNUg5VjEzSDExVjE1Wk0xNyAxM0gxOVYxNUgxN1YxM1pNOSAxN0gxMVYxOUg5VjE3Wk0xNyAxOVYxN0gxOVYxOUgxN1pNNiAxN0g1QzMuOSAxNyAzIDE2LjEgMyAxNVY1QzMgMy45IDMuOSAzIDUgM0gxNUMxNi4xIDMgMTcgMy45IDE3IDVWNkgxNVY1SDVWMTVINlYxN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TableView = createIcon('TableView', [
  [
    'path',
    {
      d: 'M19 7H9C7.9 7 7 7.9 7 9V19C7 20.1 7.9 21 9 21H19C20.1 21 21 20.1 21 19V9C21 7.9 20.1 7 19 7ZM19 9V11H9V9H19ZM13 15V13H15V15H13ZM15 17V19H13V17H15ZM11 15H9V13H11V15ZM17 13H19V15H17V13ZM9 17H11V19H9V17ZM17 19V17H19V19H17ZM6 17H5C3.9 17 3 16.1 3 15V5C3 3.9 3.9 3 5 3H15C16.1 3 17 3.9 17 5V6H15V5H5V15H6V17Z',
      key: '11sq8d',
    },
  ],
]);

export default TableView;
